export default "__VITE_ASSET__U40ud1M8__"